import { clearZustandStore } from '../store/zustand';
import { clearAllTableSessionParams } from '../features/table/utils';
import { LAST_CLEANUP_DATE_KEY } from '@/shared/hooks/useFilterReset';

export const clearAllStoresAndLocalStorage = () => {
	clearZustandStore();

	const appVersion = localStorage.getItem('app_version');
	localStorage.clear();
	if (appVersion) localStorage.setItem('app_version', appVersion);

	// Stamp today's cleanup date so useFIlterReset doesn't mistake this
	// unrelated clear for a real day boundary and wipe page filters again
	// right after ensurePage() sets them on the next mount.
	localStorage.setItem(LAST_CLEANUP_DATE_KEY, new Date().toDateString());

	clearAllTableSessionParams();
};
